import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';
import { _Number } from './service-fees-v1-rule-service-fees.types';

function resolveComWixpressServiceFeesV1ServiceFeesRulesUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'users._base_domain_': [
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
    ],
    _base_domain_: [
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
    ],
    _: [
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/service-fees-rules',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressServiceFeesV1ServiceFeesCalculateUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'users._base_domain_': [
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
    ],
    _base_domain_: [
      {
        srcPath: '/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
    ],
    _: [
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/restaurants/v1/service-fees/rules',
        destPath: '/v1/service-fees/rules',
      },
      {
        srcPath: '/_api/restaurants/v1/service-fees/calculate',
        destPath: '/v1/service-fees/calculate',
      },
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/service-fees/v1',
        destPath: '/v1',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/service-fees-rules',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_service-fees';

/**
 * The `calculateServiceFees()` function returns a Promise that resolves to an array containing the calculated fees.
 *
 *
 * The specified order information is evaluated against all rules created for the site. If the rule conditions are met, the service fee set in the rule is applied. Otherwise, no service fee is added.
 */
export function calculateServiceFees(
  payload: object
): RequestOptionsFactory<any> {
  function __calculateServiceFees({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.service.fees.v1.ServiceFeesCalculate.CalculateServiceFees',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesCalculateUrl({
        protoPath: '/v1/calculate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __calculateServiceFees;
}

/**
 * The `createRule()` function returns a Promise that resolves to the created rule.
 *
 *
 * To create multiple rules at once, use the `bulkCreateRules()` function.
 */
export function createRule(payload: object): RequestOptionsFactory<any> {
  function __createRule({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'rule.createdDate' }, { path: 'rule.updatedDate' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'rule.condition.number.value' },
          { path: 'rule.conditionTree.leftCondition.number.value' },
          { path: 'rule.conditionTree.rightCondition.number.value' },
          { path: 'rule.conditionOptions.number.value' },
          { path: 'rule.conditionTreeOptions.leftCondition.number.value' },
          { path: 'rule.conditionTreeOptions.rightCondition.number.value' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.service.fees.v1.ServiceFeesRules.CreateRule',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/rules',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'rule.createdDate' }, { path: 'rule.updatedDate' }],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rule.condition.number.value' },
              { path: 'rule.conditionTree.leftCondition.number.value' },
              { path: 'rule.conditionTree.rightCondition.number.value' },
              { path: 'rule.conditionOptions.number.value' },
              { path: 'rule.conditionTreeOptions.leftCondition.number.value' },
              { path: 'rule.conditionTreeOptions.rightCondition.number.value' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createRule;
}

/** The `createRule()` function returns a Promise that resolves to the retrieved rule. */
export function getRule(payload: object): RequestOptionsFactory<any> {
  function __getRule({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.service.fees.v1.ServiceFeesRules.GetRule',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/rules/{ruleId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'rule.createdDate' }, { path: 'rule.updatedDate' }],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rule.condition.number.value' },
              { path: 'rule.conditionTree.leftCondition.number.value' },
              { path: 'rule.conditionTree.rightCondition.number.value' },
              { path: 'rule.conditionOptions.number.value' },
              { path: 'rule.conditionTreeOptions.leftCondition.number.value' },
              { path: 'rule.conditionTreeOptions.rightCondition.number.value' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getRule;
}

/**
 * The `updateRule()` function returns a Promise that resolves to the updated rule.
 *
 *
 * Each time the task is updated, `revision` increments by 1. The existing `revision` must be included when updating the task. This ensures you're working with the latest task and prevents unintended overwrites.
 *
 * To update multiple rules at once, use the `bulkUpdateRules()` function.
 */
export function updateRule(payload: object): RequestOptionsFactory<any> {
  function __updateRule({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'rule.createdDate' }, { path: 'rule.updatedDate' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'rule.condition.number.value' },
          { path: 'rule.conditionTree.leftCondition.number.value' },
          { path: 'rule.conditionTree.rightCondition.number.value' },
          { path: 'rule.conditionOptions.number.value' },
          { path: 'rule.conditionTreeOptions.leftCondition.number.value' },
          { path: 'rule.conditionTreeOptions.rightCondition.number.value' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'PATCH' as any,
      methodFqn: 'com.wixpress.service.fees.v1.ServiceFeesRules.UpdateRule',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/rules/{rule.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'rule.createdDate' }, { path: 'rule.updatedDate' }],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rule.condition.number.value' },
              { path: 'rule.conditionTree.leftCondition.number.value' },
              { path: 'rule.conditionTree.rightCondition.number.value' },
              { path: 'rule.conditionOptions.number.value' },
              { path: 'rule.conditionTreeOptions.leftCondition.number.value' },
              { path: 'rule.conditionTreeOptions.rightCondition.number.value' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateRule;
}

/**
 * The `deleteRule()` function returns a Promise that resolves to void.
 *
 *
 * To delete multiple rules at once, use the `bulkDeleteRules()` function.
 */
export function deleteRule(payload: object): RequestOptionsFactory<any> {
  function __deleteRule({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'DELETE' as any,
      methodFqn: 'com.wixpress.service.fees.v1.ServiceFeesRules.DeleteRule',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/rules/{ruleId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteRule;
}

/**
 * The `listRules()` function returns a Promise that resolves to an array of the retrieved rules.
 *
 *
 * You can filter by location or app that the rules are associated with.
 */
export function listRules(payload: object): RequestOptionsFactory<any> {
  function __listRules({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.service.fees.v1.ServiceFeesRules.ListRules',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/rules',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rules.createdDate' },
              { path: 'rules.updatedDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rules.condition.number.value' },
              { path: 'rules.conditionTree.leftCondition.number.value' },
              { path: 'rules.conditionTree.rightCondition.number.value' },
              { path: 'rules.conditionOptions.number.value' },
              { path: 'rules.conditionTreeOptions.leftCondition.number.value' },
              {
                path: 'rules.conditionTreeOptions.rightCondition.number.value',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listRules;
}

/**
 * Creates a query to retrieve a list of rules.
 *
 *
 * The `queryRules()` function builds a query to retrieve a list of up to 1,000 rules and returns a `RulesQueryBuilder` object.
 *
 * The returned object contains the query definition which is typically used to run the query using the [`find()`](/service-fees/rules-query-builder/find) function.
 *
 * You can refine the query by chaining `RulesQueryBuilder` functions onto the query. `RulesQueryBuilder` functions enable you to sort, filter, and control the results that `queryRules()` returns. The functions that are chained to `queryRules()` are applied in the order they are called.
 *
 * `queryRules()` runs with the following `RulesQueryBuilder` defaults that you can override:
 *
 * * [`limit(50)`](/service-fees/rules-query-builder/limit)
 * * [`ascending('entityId')`](/service-fees/rules-query-builder/ascending)
 *
 * The following `QueryRulesBuilder` functions are supported for the `queryRules()` function. For a full description of the Rules object, see the object returned for the [`items`](/service-fees/rules-query-result/items) property in `RulesQueryResult`.
 */
export function queryRules(payload: object): RequestOptionsFactory<any> {
  function __queryRules({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'query.sort.origin.latitude' },
          { path: 'query.sort.origin.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.service.fees.v1.ServiceFeesRules.QueryRules',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/rules/query',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rules.createdDate' },
              { path: 'rules.updatedDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rules.condition.number.value' },
              { path: 'rules.conditionTree.leftCondition.number.value' },
              { path: 'rules.conditionTree.rightCondition.number.value' },
              { path: 'rules.conditionOptions.number.value' },
              { path: 'rules.conditionTreeOptions.leftCondition.number.value' },
              {
                path: 'rules.conditionTreeOptions.rightCondition.number.value',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryRules;
}

/**
 * The `bulkCreateRules()` function returns a Promise that resolves to the created rules.
 *
 *
 * To create only one rule, use the `createRule()` function.
 */
export function bulkCreateRules(payload: object): RequestOptionsFactory<any> {
  function __bulkCreateRules({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'rules.createdDate' }, { path: 'rules.updatedDate' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'rules.condition.number.value' },
          { path: 'rules.conditionTree.leftCondition.number.value' },
          { path: 'rules.conditionTree.rightCondition.number.value' },
          { path: 'rules.conditionOptions.number.value' },
          { path: 'rules.conditionTreeOptions.leftCondition.number.value' },
          { path: 'rules.conditionTreeOptions.rightCondition.number.value' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.service.fees.v1.ServiceFeesRules.BulkCreateRules',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/bulk/rules/create',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.rule.createdDate' },
              { path: 'results.rule.updatedDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'results.rule.condition.number.value' },
              { path: 'results.rule.conditionTree.leftCondition.number.value' },
              {
                path: 'results.rule.conditionTree.rightCondition.number.value',
              },
              { path: 'results.rule.conditionOptions.number.value' },
              {
                path: 'results.rule.conditionTreeOptions.leftCondition.number.value',
              },
              {
                path: 'results.rule.conditionTreeOptions.rightCondition.number.value',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkCreateRules;
}

/**
 * The `bulkUpdateRules()` function returns a Promise that resolves to the updated rules.
 *
 *
 * Each time the task is updated, `revision` increments by 1. The existing `revision` must be included when updating the task. This ensures you're working with the latest task and prevents unintended overwrites.
 *
 * To update only one rule, use the `updateRule()` function.
 */
export function bulkUpdateRules(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateRules({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'rules.mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'rules.rule.createdDate' },
          { path: 'rules.rule.updatedDate' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'rules.rule.condition.number.value' },
          { path: 'rules.rule.conditionTree.leftCondition.number.value' },
          { path: 'rules.rule.conditionTree.rightCondition.number.value' },
          { path: 'rules.rule.conditionOptions.number.value' },
          {
            path: 'rules.rule.conditionTreeOptions.leftCondition.number.value',
          },
          {
            path: 'rules.rule.conditionTreeOptions.rightCondition.number.value',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.service.fees.v1.ServiceFeesRules.BulkUpdateRules',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/bulk/rules/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.rule.createdDate' },
              { path: 'results.rule.updatedDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'results.rule.condition.number.value' },
              { path: 'results.rule.conditionTree.leftCondition.number.value' },
              {
                path: 'results.rule.conditionTree.rightCondition.number.value',
              },
              { path: 'results.rule.conditionOptions.number.value' },
              {
                path: 'results.rule.conditionTreeOptions.leftCondition.number.value',
              },
              {
                path: 'results.rule.conditionTreeOptions.rightCondition.number.value',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateRules;
}

/**
 * The `bulkDeleteRules()` function returns a Promise that resolves to the deleted rules.
 *
 *
 * To delete only one rule, use the `deleteRule()` function.
 */
export function bulkDeleteRules(payload: object): RequestOptionsFactory<any> {
  function __bulkDeleteRules({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.service.fees.v1.ServiceFeesRules.BulkDeleteRules',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/bulk/rules/delete',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.rule.createdDate' },
              { path: 'results.rule.updatedDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'results.rule.condition.number.value' },
              { path: 'results.rule.conditionTree.leftCondition.number.value' },
              {
                path: 'results.rule.conditionTree.rightCondition.number.value',
              },
              { path: 'results.rule.conditionOptions.number.value' },
              {
                path: 'results.rule.conditionTreeOptions.leftCondition.number.value',
              },
              {
                path: 'results.rule.conditionTreeOptions.rightCondition.number.value',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkDeleteRules;
}

/**
 * Synchronously update tags on multiple rules.
 * If you specify a tag in both `assignTags` and `unassignTags`, it is assigned.
 */
export function bulkUpdateRuleTags(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateRuleTags({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.service.fees.v1.ServiceFeesRules.BulkUpdateRuleTags',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/bulk/rules/update-tags',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateRuleTags;
}

/**
 * Asynchronously update tags on multiple rules according to the specified filter.
 * If a filter isn't specified, this method updates all rules.
 * If you specify a tag in both `assignTags` and `unassignTags`, it is assigned.
 */
export function bulkUpdateRuleTagsByFilter(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateRuleTagsByFilter({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.service.fees.v1.rule',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.service.fees.v1.ServiceFeesRules.BulkUpdateRuleTagsByFilter',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressServiceFeesV1ServiceFeesRulesUrl({
        protoPath: '/v1/bulk/rules/update-tags-by-filter',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateRuleTagsByFilter;
}
